import axios from '@/utils/request'

/**
 * 用户列表
 */
const getUserList = (params, options) => axios({
  url: '/user',
  params,
  options
})

/**
 * 导出Excel
 */
const getExcel = params => axios({
  url: 'user/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 用户详情
 */
const getUserDetails = id => axios({
  url: `user/${id}`
})

/**
 * 拜访申请记录
 */
const getVisitorList = (params, options) => axios({
  url: 'user/visitor',
  params,
  options
})

/**
 * 放行申请记录
 */
const getReleaseList = (params, options) => axios({
  url: 'user/release',
  params,
  options
})

/**
 * 放行申请记录详情
 */
const getVisitInfo = id => axios({
  url: `user/release/${id}`
})

/**
 * 拜访申请记录详情
 */
const getPassInfo = id => axios({
  url: `user/visitor/${id}`
})

/**
 * 放行申请操作
 */
const putApply = (data) => axios({
  url: 'user/release',
  method: 'put',
  data
})

/**
 * 更改用户是否显禁用状态
 */
const disableUser = (uuid) => axios({
  url: `user/${uuid}`,
  method: 'put',
})

/**
 * 导出放行申请记录
 */
const downReleaseExcel = (params) => axios({
  url: 'user/release/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 导出拜访申请记录
 */
const downVisitExcel = (params) => axios({
  url: 'user/visitor/excel',
  responseType: 'arraybuffer',
  params
})

export {
  getUserList,
  getExcel,
  getUserDetails,
  getVisitorList,
  getReleaseList,
  getVisitInfo,
  getPassInfo,
  putApply,
  disableUser,
  downReleaseExcel,
  downVisitExcel
}
